import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { syncCommissionStepStatus } from 'redux/Commissioning';

export function useSyncFormStep(value, formState) {
  const dispatch = useDispatch();
  const { isDirty } = formState;

  useEffect(() => {
    dispatch(syncCommissionStepStatus(value, { isDirty }));
  }, [dispatch, value, isDirty]);
}
